// extracted by mini-css-extract-plugin
module.exports = {"header":"_99551c8aa8--header--ufTSc","label":"_99551c8aa8--label--i3oJ8","buttons":"_99551c8aa8--buttons--zvlVG"};